/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InactiveCleanupCriteriaDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const InactiveCleanupCriteriaDTOReasonsEnum = {
    DetailPageRemoved: 'DETAIL_PAGE_REMOVED',
    PricingIssue: 'PRICING_ISSUE',
    OutOfStock: 'OUT_OF_STOCK',
    GpsrMissing: 'GPSR_MISSING',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the InactiveCleanupCriteriaDTO interface.
 */
export function instanceOfInactiveCleanupCriteriaDTO(value) {
    if (!('marketplace' in value) || value['marketplace'] === undefined)
        return false;
    return true;
}
export function InactiveCleanupCriteriaDTOFromJSON(json) {
    return InactiveCleanupCriteriaDTOFromJSONTyped(json, false);
}
export function InactiveCleanupCriteriaDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
        'minInactiveDays': json['minInactiveDays'] == null ? undefined : json['minInactiveDays'],
    };
}
export function InactiveCleanupCriteriaDTOToJSON(json) {
    return InactiveCleanupCriteriaDTOToJSONTyped(json, false);
}
export function InactiveCleanupCriteriaDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'reasons': value['reasons'],
        'minInactiveDays': value['minInactiveDays'],
    };
}
